import { all } from "redux-saga/effects";
import { TableSaga, TableBookingSaga } from "../Table/TableSagas";
import { ThemeSaga } from "../Theme/ThemeSaga";
import { TimeSlotsSaga } from "../TimeAndDate/TimeAndDateSaga";

export function* watchSagas() {
  yield all([TableSaga(), TableBookingSaga(), ThemeSaga(), TimeSlotsSaga()]);
}
